import { useEffect, useState } from 'react'
import { DAY_IN_SECONDS, isPhone } from '../common/constants'
import { ChartsPageTimeController } from '../components'
import { useAccountContext } from '../contexts'
import { ManageDataByCharts } from './ManageDataByCharts'
import { Layout } from '../layouts/Layout'
import { Viewport } from '../common/types'

export const DEFAULT_DATE_PERIOD_IN_MS = 14 * DAY_IN_SECONDS * 1000

export function ManageDataPage() {
  const { selectedDevice, selectDevice } = useAccountContext()
  const path = window.location.pathname

  const [viewport, setViewport] = useState<Viewport>({
    minimum: new Date().setHours(0, 0, 0, 0) - DEFAULT_DATE_PERIOD_IN_MS,
    maximum: new Date().setHours(23, 59, 59, 999),
  })

  useEffect(() => {
    !isPhone && selectDevice('')
  }, [path]) // eslint-disable-line react-hooks/exhaustive-deps

  function updateDay(start: number, end: number, isToday: boolean) {
    setViewport({
      minimum: start,
      maximum: end,
    })
  }

  return (
    <Layout>
      <div>
        <div className="flex flex-row">
          <ChartsPageTimeController updateDay={updateDay} />
        </div>
        <div className="overflow-y-auto overflow">
          <ManageDataByCharts sigfoxId={selectedDevice} viewport={viewport} />
        </div>
      </div>
    </Layout>
  )
}
